<template>
<el-dialog class='quotas-required-dialog' title="永久项目额度不足" size='small' :visible.sync="dialogVisible" @close="close">
  <div v-if="organization">
    <p v-if="overdate">企业套餐已过期，请联系管理员续费或升级</p>
    <p v-else>企业套餐额度不足，请联系管理员续费或升级</p>
  </div>
  <div v-else>
    <p>您的永久项目额度不足，如果继续将会创建临时项目。临时项目会免费浏览8小时，之后会自动删除。
    </p>
    <br />
    <p>您可以通过以下方式增加永久项目额度：</p>
    <p>
      1. 购买单次项目额度；
    </p>
    <p>2. 购买会员套餐，升级账户；<a class='recommand' href='/price?closeOnPQuota=true' target='_blank'>查看优惠</a></p>
  </div>

  <div class='buttons' slot='footer'>
    <div v-if="organization">
      <a class='el-button el-button--primary' @click="close">关闭</a>
    </div>
    <div v-else>
      <a class='el-button el-button--text' href="/price?closeOnPQuota=true" target='_blank'>购买会员</a>
      <!-- <el-button type="primary" @click="next({path: '/price'})">购买额度</el-button> -->
      <el-button type='primary' @click="purchase">购买单次额度</el-button>
    </div>
  </div>
</el-dialog>
</template>

<style lang="scss" scoped>
.quotas-required-dialog {
    line-height: 1.15;
    p {
        line-height: 1.5;
        margin: 0.67em 0;
    }

    .recommand {
        color: $color-primary;
    }

    .verified {
        color: $font-color-light;
    }
}
</style>

<script>
import bus from '@/utils/bus'

export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    overdate() {
      return this.$store.getters['quota/overdate']
    }
  },
  methods: {
    open() {
      let vm = this
      vm.dialogVisible = true

      bus.$on('GetPermanentsQuota', vm.onGetQuota)
    },
    close() {
      this.dialogVisible = false
      bus.$off('GetPermanentsQuota', this.onGetQuota)
      this.$emit('close')
    },
    onGetQuota(diff) {
      let _diff = diff === null ? '不限次数' : `${diff}次`
      this.$message(`已为您添加永久项目额度：${_diff}`)
      this.close()
    },
    purchase() {
      let vm = this
      vm.$upgradeProject({
        projectId: vm.project.id,
        logoEnabled: vm.project.permissions.change_logo,
        success: function() {
          alert('购买成功！')
          window.location.reload()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// quotas_required.dialog.vue?cdc3aaa8